import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class EarlySettlementsService {
  constructor(private http: HttpClientService) {}

  public getEarlySettlement(termination_quote_id): Observable<any[]> {
    return this.http
      .get("/api/early_settlement/" + termination_quote_id)
      .pipe(tap((_) => console.log("EarlySettlementsService.getEarlySettlement: Ok.")));
  }
}
